webpackJsonp([22739984247581],{

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(5);
	
	var _legends = __webpack_require__(48);
	
	var _enhance = __webpack_require__(214);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _setDisplayName = __webpack_require__(24);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _props = __webpack_require__(88);
	
	var _ChordRibbons = __webpack_require__(340);
	
	var _ChordRibbons2 = _interopRequireDefault(_ChordRibbons);
	
	var _ChordArcs = __webpack_require__(338);
	
	var _ChordArcs2 = _interopRequireDefault(_ChordArcs);
	
	var _ChordLabels = __webpack_require__(339);
	
	var _ChordLabels2 = _interopRequireDefault(_ChordLabels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chord = function Chord(_ref) {
	    var margin = _ref.margin,
	        width = _ref.width,
	        height = _ref.height,
	        outerWidth = _ref.outerWidth,
	        outerHeight = _ref.outerHeight,
	        arcBorderWidth = _ref.arcBorderWidth,
	        getArcBorderColor = _ref.getArcBorderColor,
	        ribbonBorderWidth = _ref.ribbonBorderWidth,
	        getRibbonBorderColor = _ref.getRibbonBorderColor,
	        enableLabel = _ref.enableLabel,
	        getLabel = _ref.getLabel,
	        labelOffset = _ref.labelOffset,
	        labelRotation = _ref.labelRotation,
	        getLabelTextColor = _ref.getLabelTextColor,
	        arcGenerator = _ref.arcGenerator,
	        ribbonGenerator = _ref.ribbonGenerator,
	        theme = _ref.theme,
	        isInteractive = _ref.isInteractive,
	        tooltipFormat = _ref.tooltipFormat,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness,
	        ribbons = _ref.ribbons,
	        arcs = _ref.arcs,
	        radius = _ref.radius,
	        setCurrentArc = _ref.setCurrentArc,
	        setCurrentRibbon = _ref.setCurrentRibbon,
	        getArcOpacity = _ref.getArcOpacity,
	        getRibbonOpacity = _ref.getRibbonOpacity,
	        legends = _ref.legends;
	
	    var centerX = width / 2;
	    var centerY = height / 2;
	
	    var motionProps = {
	        animate: animate,
	        motionDamping: motionDamping,
	        motionStiffness: motionStiffness
	    };
	
	    var legendData = arcs.map(function (arc) {
	        return {
	            label: arc.id,
	            fill: arc.color
	        };
	    });
	
	    return _react2.default.createElement(
	        _core.Container,
	        { isInteractive: isInteractive, theme: theme },
	        function (_ref2) {
	            var showTooltip = _ref2.showTooltip,
	                hideTooltip = _ref2.hideTooltip;
	
	            return _react2.default.createElement(
	                _core.SvgWrapper,
	                { width: outerWidth, height: outerHeight, margin: margin },
	                _react2.default.createElement(
	                    'g',
	                    { transform: 'translate(' + centerX + ', ' + centerY + ')' },
	                    _react2.default.createElement(_ChordRibbons2.default, _extends({
	                        ribbons: ribbons,
	                        shapeGenerator: ribbonGenerator,
	                        borderWidth: ribbonBorderWidth,
	                        getBorderColor: getRibbonBorderColor,
	                        getOpacity: getRibbonOpacity,
	                        setCurrent: setCurrentRibbon,
	                        theme: theme,
	                        tooltipFormat: tooltipFormat,
	                        showTooltip: showTooltip,
	                        hideTooltip: hideTooltip
	                    }, motionProps)),
	                    _react2.default.createElement(_ChordArcs2.default, _extends({
	                        arcs: arcs,
	                        shapeGenerator: arcGenerator,
	                        borderWidth: arcBorderWidth,
	                        getBorderColor: getArcBorderColor,
	                        getOpacity: getArcOpacity,
	                        setCurrent: setCurrentArc,
	                        theme: theme,
	                        tooltipFormat: tooltipFormat,
	                        showTooltip: showTooltip,
	                        hideTooltip: hideTooltip
	                    }, motionProps)),
	                    enableLabel && _react2.default.createElement(_ChordLabels2.default, _extends({
	                        arcs: arcs,
	                        radius: radius + labelOffset,
	                        rotation: labelRotation,
	                        getLabel: getLabel,
	                        getColor: getLabelTextColor,
	                        theme: theme
	                    }, motionProps))
	                ),
	                legends.map(function (legend, i) {
	                    return _react2.default.createElement(_legends.BoxLegendSvg, _extends({
	                        key: i
	                    }, legend, {
	                        containerWidth: width,
	                        containerHeight: height,
	                        data: legendData
	                    }));
	                })
	            );
	        }
	    );
	};
	
	Chord.propTypes = _props.ChordPropTypes;
	
	exports.default = (0, _setDisplayName2.default)('Chord')((0, _enhance2.default)(Chord));

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _core = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var ChordArcTooltip = function ChordArcTooltip(_ref) {
	    var arc = _ref.arc,
	        theme = _ref.theme,
	        format = _ref.format;
	    return _react2.default.createElement(_core.BasicTooltip, {
	        id: arc.id,
	        value: arc.value,
	        color: arc.color,
	        enableChip: true,
	        theme: theme,
	        format: format
	    });
	};
	
	ChordArcTooltip.propTypes = {
	    arc: _propTypes2.default.object.isRequired,
	    theme: _propTypes2.default.object.isRequired,
	    format: _propTypes2.default.func
	};
	
	exports.default = (0, _pure2.default)(ChordArcTooltip);

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(10);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _core = __webpack_require__(5);
	
	var _ChordArcTooltip = __webpack_require__(212);
	
	var _ChordArcTooltip2 = _interopRequireDefault(_ChordArcTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChordArcs = function ChordArcs(_ref) {
	    var arcs = _ref.arcs,
	        borderWidth = _ref.borderWidth,
	        getBorderColor = _ref.getBorderColor,
	        getOpacity = _ref.getOpacity,
	        shapeGenerator = _ref.shapeGenerator,
	        theme = _ref.theme,
	        tooltipFormat = _ref.tooltipFormat,
	        setCurrent = _ref.setCurrent,
	        showTooltip = _ref.showTooltip,
	        hideTooltip = _ref.hideTooltip,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness;
	
	    var commonProps = function commonProps(arc) {
	        var arcTooltip = _react2.default.createElement(_ChordArcTooltip2.default, { arc: arc, theme: theme, format: tooltipFormat });
	
	        return {
	            strokeWidth: borderWidth,
	            onMouseEnter: function onMouseEnter(e) {
	                setCurrent(arc);
	                showTooltip(arcTooltip, e);
	            },
	            onMouseMove: function onMouseMove(e) {
	                showTooltip(arcTooltip, e);
	            },
	            onMouseLeave: function onMouseLeave() {
	                setCurrent(null);
	                hideTooltip();
	            }
	        };
	    };
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            arcs.map(function (arc) {
	                var opacity = getOpacity(arc);
	
	                return _react2.default.createElement('path', _extends({
	                    key: arc.key,
	                    d: shapeGenerator(arc),
	                    fill: arc.color,
	                    fillOpacity: opacity,
	                    stroke: getBorderColor(arc),
	                    strokeOpacity: opacity
	                }, commonProps(arc)));
	            })
	        );
	    }
	
	    var springConfig = {
	        damping: motionDamping,
	        stiffness: motionStiffness,
	        precision: 0.001
	    };
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            styles: arcs.map(function (arc) {
	                return {
	                    key: arc.key,
	                    data: arc,
	                    style: _extends({
	                        startAngle: (0, _reactMotion.spring)(arc.startAngle, springConfig),
	                        endAngle: (0, _reactMotion.spring)(arc.endAngle, springConfig),
	                        opacity: (0, _reactMotion.spring)(getOpacity(arc), springConfig)
	                    }, (0, _core.colorMotionSpring)(arc.color, springConfig))
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref2) {
	                    var key = _ref2.key,
	                        style = _ref2.style,
	                        arc = _ref2.data;
	
	                    var color = (0, _core.getInterpolatedColor)(style);
	
	                    return _react2.default.createElement('path', _extends({
	                        key: key,
	                        d: shapeGenerator({
	                            startAngle: style.startAngle,
	                            endAngle: style.endAngle
	                        }),
	                        fill: color,
	                        fillOpacity: style.opacity,
	                        stroke: getBorderColor(_extends({}, arc, { color: color })),
	                        strokeOpacity: style.opacity
	                    }, commonProps(arc)));
	                })
	            );
	        }
	    );
	};
	
	ChordArcs.propTypes = _extends({
	    arcs: _propTypes2.default.array.isRequired,
	    shapeGenerator: _propTypes2.default.func.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    getBorderColor: _propTypes2.default.func.isRequired,
	    getOpacity: _propTypes2.default.func.isRequired,
	    setCurrent: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired,
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	}, _core.motionPropTypes);
	
	exports.default = (0, _pure2.default)(ChordArcs);

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(6);
	
	var _core = __webpack_require__(5);
	
	var _props3 = __webpack_require__(88);
	
	var _enhance = __webpack_require__(214);
	
	var _enhance2 = _interopRequireDefault(_enhance);
	
	var _ChordArcTooltip = __webpack_require__(212);
	
	var _ChordArcTooltip2 = _interopRequireDefault(_ChordArcTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ChordCanvas = function (_Component) {
	    _inherits(ChordCanvas, _Component);
	
	    function ChordCanvas() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ChordCanvas);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleMouseHover = function (showTooltip, hideTooltip, event) {
	            if (_this.props.isInteractive !== true) return;
	
	            var _getRelativeCursor = (0, _core.getRelativeCursor)(_this.surface, event),
	                x = _getRelativeCursor[0],
	                y = _getRelativeCursor[1];
	
	            var _this$props = _this.props,
	                width = _this$props.width,
	                height = _this$props.height,
	                margin = _this$props.margin,
	                radius = _this$props.radius,
	                innerRadius = _this$props.innerRadius,
	                arcs = _this$props.arcs,
	                setCurrentArc = _this$props.setCurrentArc,
	                theme = _this$props.theme;
	
	
	            var centerX = width / 2 + margin.left;
	            var centerY = height / 2 + margin.top;
	
	            var arc = (0, _core.getHoveredArc)(centerX, centerY, radius, innerRadius, arcs, x, y);
	            if (arc) {
	                setCurrentArc(arc);
	                showTooltip(_react2.default.createElement(_ChordArcTooltip2.default, { arc: arc, theme: theme }), event);
	            } else {
	                setCurrentArc(null);
	                hideTooltip();
	            }
	        }, _this.handleMouseLeave = function (hideTooltip) {
	            if (_this.props.isInteractive !== true) return;
	
	            _this.props.setCurrentArc(null);
	            hideTooltip();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    ChordCanvas.prototype.componentDidMount = function componentDidMount() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    ChordCanvas.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
	        if (this.props.outerWidth !== props.outerWidth || this.props.outerHeight !== props.outerHeight || this.props.isInteractive !== props.isInteractive || this.props.theme !== props.theme) {
	            return true;
	        } else {
	            this.draw(props);
	            return false;
	        }
	    };
	
	    ChordCanvas.prototype.componentDidUpdate = function componentDidUpdate() {
	        this.ctx = this.surface.getContext('2d');
	        this.draw(this.props);
	    };
	
	    ChordCanvas.prototype.draw = function draw(props) {
	        var _this2 = this;
	
	        var pixelRatio = props.pixelRatio,
	            width = props.width,
	            height = props.height,
	            margin = props.margin,
	            outerWidth = props.outerWidth,
	            outerHeight = props.outerHeight,
	            enableLabel = props.enableLabel,
	            getLabel = props.getLabel,
	            labelOffset = props.labelOffset,
	            labelRotation = props.labelRotation,
	            getLabelTextColor = props.getLabelTextColor,
	            arcGenerator = props.arcGenerator,
	            ribbonGenerator = props.ribbonGenerator,
	            theme = props.theme,
	            ribbons = props.ribbons,
	            arcs = props.arcs,
	            radius = props.radius,
	            getArcOpacity = props.getArcOpacity,
	            getRibbonOpacity = props.getRibbonOpacity;
	
	
	        this.surface.width = outerWidth * pixelRatio;
	        this.surface.height = outerHeight * pixelRatio;
	
	        this.ctx.scale(pixelRatio, pixelRatio);
	
	        var centerX = width / 2 + margin.left;
	        var centerY = height / 2 + margin.top;
	
	        this.ctx.clearRect(0, 0, outerWidth, outerHeight);
	        this.ctx.translate(centerX, centerY);
	
	        ribbonGenerator.context(this.ctx);
	        ribbons.forEach(function (ribbon) {
	            _this2.ctx.save();
	            _this2.ctx.globalAlpha = getRibbonOpacity(ribbon);
	
	            _this2.ctx.beginPath();
	            ribbonGenerator(ribbon);
	            _this2.ctx.fillStyle = ribbon.source.color;
	            _this2.ctx.fill();
	
	            _this2.ctx.restore();
	        });
	
	        arcGenerator.context(this.ctx);
	        arcs.forEach(function (arc) {
	            _this2.ctx.save();
	            _this2.ctx.globalAlpha = getArcOpacity(arc);
	
	            _this2.ctx.beginPath();
	            arcGenerator(arc);
	            _this2.ctx.fillStyle = arc.color;
	            _this2.ctx.fill();
	
	            _this2.ctx.restore();
	
	            if (enableLabel) {
	                var labelTextColor = getLabelTextColor(arc, theme);
	                var angle = (0, _core.midAngle)(arc);
	                var _props = (0, _core.getPolarLabelProps)(radius + labelOffset, angle, labelRotation);
	
	                _this2.ctx.save();
	                _this2.ctx.translate(_props.x, _props.y);
	                _this2.ctx.rotate((0, _core.degreesToRadians)(_props.rotate));
	
	                _this2.ctx.textAlign = _props.align;
	                _this2.ctx.textBaseline = _props.baseline;
	                _this2.ctx.fillStyle = labelTextColor;
	                _this2.ctx.fillText(getLabel(arc), 0, 0);
	
	                _this2.ctx.restore();
	            }
	        });
	    };
	
	    ChordCanvas.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props2 = this.props,
	            outerWidth = _props2.outerWidth,
	            outerHeight = _props2.outerHeight,
	            pixelRatio = _props2.pixelRatio,
	            isInteractive = _props2.isInteractive,
	            theme = _props2.theme;
	
	
	        return _react2.default.createElement(
	            _core.Container,
	            { isInteractive: isInteractive, theme: theme },
	            function (_ref) {
	                var showTooltip = _ref.showTooltip,
	                    hideTooltip = _ref.hideTooltip;
	                return _react2.default.createElement('canvas', {
	                    ref: function ref(surface) {
	                        _this3.surface = surface;
	                    },
	                    width: outerWidth * pixelRatio,
	                    height: outerHeight * pixelRatio,
	                    style: {
	                        width: outerWidth,
	                        height: outerHeight
	                    },
	                    onMouseEnter: (0, _lodash.partial)(_this3.handleMouseHover, showTooltip, hideTooltip),
	                    onMouseMove: (0, _lodash.partial)(_this3.handleMouseHover, showTooltip, hideTooltip),
	                    onMouseLeave: (0, _lodash.partial)(_this3.handleMouseLeave, hideTooltip)
	                });
	            }
	        );
	    };
	
	    return ChordCanvas;
	}(_react.Component);
	
	ChordCanvas.propTypes = _props3.ChordPropTypes;
	
	exports.default = (0, _enhance2.default)(ChordCanvas);

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(10);
	
	var _core = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChordLabels = function ChordLabels(_ref) {
	    var arcs = _ref.arcs,
	        radius = _ref.radius,
	        rotation = _ref.rotation,
	        getLabel = _ref.getLabel,
	        getColor = _ref.getColor,
	        theme = _ref.theme,
	        animate = _ref.animate,
	        motionDamping = _ref.motionDamping,
	        motionStiffness = _ref.motionStiffness;
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            arcs.map(function (arc) {
	                var color = getColor(arc, theme);
	                var angle = (0, _core.midAngle)(arc);
	                var textProps = (0, _core.getPolarLabelProps)(radius, angle, rotation);
	
	                return _react2.default.createElement(
	                    'text',
	                    {
	                        key: arc.key,
	                        transform: 'translate(' + textProps.x + ', ' + textProps.y + ') rotate(' + textProps.rotate + ')',
	                        style: { pointerEvents: 'none', fill: color },
	                        textAnchor: textProps.align,
	                        alignmentBaseline: textProps.baseline
	                    },
	                    getLabel(arc)
	                );
	            })
	        );
	    }
	
	    var springConfig = {
	        damping: motionDamping,
	        stiffness: motionStiffness
	    };
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            styles: arcs.map(function (arc) {
	                var angle = (0, _core.midAngle)(arc);
	
	                return {
	                    key: arc.key,
	                    data: arc,
	                    style: {
	                        angle: (0, _reactMotion.spring)(angle, springConfig)
	                    }
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref2) {
	                    var key = _ref2.key,
	                        style = _ref2.style,
	                        arc = _ref2.data;
	
	                    var color = getColor(arc, theme);
	                    var textProps = (0, _core.getPolarLabelProps)(radius, style.angle, rotation);
	
	                    return _react2.default.createElement(
	                        'text',
	                        {
	                            key: key,
	                            transform: 'translate(' + textProps.x + ', ' + textProps.y + ') rotate(' + textProps.rotate + ')',
	                            style: { pointerEvents: 'none', fill: color },
	                            textAnchor: textProps.align,
	                            alignmentBaseline: textProps.baseline
	                        },
	                        getLabel(arc)
	                    );
	                })
	            );
	        }
	    );
	};
	
	ChordLabels.propTypes = _extends({
	    arcs: _propTypes2.default.array.isRequired,
	    radius: _propTypes2.default.number.isRequired,
	    rotation: _propTypes2.default.number.isRequired,
	    getLabel: _propTypes2.default.func.isRequired,
	    getColor: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired
	}, _core.motionPropTypes);
	
	exports.default = ChordLabels;

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(6);
	
	var _reactMotion = __webpack_require__(10);
	
	var _d3Format = __webpack_require__(57);
	
	var _compose = __webpack_require__(12);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withPropsOnChange = __webpack_require__(15);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _core = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Used to get ribbon angles, instead of using source and target arcs,
	 * we sort arcs by value to have smooth transitions, otherwise,
	 * if source|target arc value becomes greater than the other,
	 * the ribbon will be reversed.
	 *
	 * @param {Object}  source
	 * @param {Object}  target
	 * @param {boolean} useMiddleAngle
	 * @param {Object}  [springConfig]
	 * @return {Object}
	 */
	var getRibbonAngles = function getRibbonAngles(_ref, useMiddleAngle, springConfig) {
	    var source = _ref.source,
	        target = _ref.target;
	
	    var firstArc = void 0;
	    var secondArc = void 0;
	    if (source.startAngle < target.startAngle) {
	        firstArc = source;
	        secondArc = target;
	    } else {
	        firstArc = target;
	        secondArc = source;
	    }
	
	    var angles = void 0;
	    if (useMiddleAngle === true) {
	        var firstMiddleAngle = (0, _core.midAngle)(firstArc);
	        var secondMiddleAngle = (0, _core.midAngle)(secondArc);
	
	        angles = {
	            sourceStartAngle: firstMiddleAngle,
	            sourceEndAngle: firstMiddleAngle,
	            targetStartAngle: secondMiddleAngle,
	            targetEndAngle: secondMiddleAngle
	        };
	    } else {
	        angles = {
	            sourceStartAngle: firstArc.startAngle,
	            sourceEndAngle: firstArc.endAngle,
	            targetStartAngle: secondArc.startAngle,
	            targetEndAngle: secondArc.endAngle
	        };
	    }
	
	    if (!springConfig) return angles;
	
	    return (0, _lodash.mapValues)(angles, function (angle) {
	        return (0, _reactMotion.spring)(angle, springConfig);
	    });
	};
	
	var ribbonWillEnter = function ribbonWillEnter(_ref2) {
	    var ribbon = _ref2.data;
	    return _extends({}, getRibbonAngles(ribbon, true), {
	        opacity: 0
	    }, (0, _core.colorMotionSpring)(ribbon.source.color));
	};
	
	var ribbonWillLeave = function ribbonWillLeave(springConfig) {
	    return function (_ref3) {
	        var ribbon = _ref3.data;
	        return _extends({}, getRibbonAngles(ribbon, true, springConfig), {
	            opacity: 0
	        }, (0, _core.colorMotionSpring)(ribbon.source.color, springConfig));
	    };
	};
	
	var ChordRibbons = function ChordRibbons(_ref4) {
	    var ribbons = _ref4.ribbons,
	        shapeGenerator = _ref4.shapeGenerator,
	        borderWidth = _ref4.borderWidth,
	        getBorderColor = _ref4.getBorderColor,
	        getOpacity = _ref4.getOpacity,
	        theme = _ref4.theme,
	        tooltipFormat = _ref4.tooltipFormat,
	        setCurrent = _ref4.setCurrent,
	        showTooltip = _ref4.showTooltip,
	        hideTooltip = _ref4.hideTooltip,
	        animate = _ref4.animate,
	        motionDamping = _ref4.motionDamping,
	        motionStiffness = _ref4.motionStiffness;
	
	    var commonProps = function commonProps(ribbon) {
	        var ribbonTooltip = _react2.default.createElement(_core.TableTooltip, {
	            theme: theme,
	            rows: [[_react2.default.createElement(_core.Chip, { key: 'chip', color: ribbon.source.color }), _react2.default.createElement(
	                'strong',
	                { key: 'id' },
	                ribbon.source.id
	            ), tooltipFormat ? tooltipFormat(ribbon.source.value) : ribbon.source.value], [_react2.default.createElement(_core.Chip, { key: 'chip', color: ribbon.target.color }), _react2.default.createElement(
	                'strong',
	                { key: 'id' },
	                ribbon.target.id
	            ), tooltipFormat ? tooltipFormat(ribbon.target.value) : ribbon.target.value]]
	        });
	
	        return {
	            strokeWidth: borderWidth,
	            onMouseEnter: function onMouseEnter(e) {
	                setCurrent(ribbon);
	                showTooltip(ribbonTooltip, e);
	            },
	            onMouseMove: function onMouseMove(e) {
	                showTooltip(ribbonTooltip, e);
	            },
	            onMouseLeave: function onMouseLeave() {
	                setCurrent(null);
	                hideTooltip();
	            }
	        };
	    };
	
	    if (animate !== true) {
	        return _react2.default.createElement(
	            'g',
	            null,
	            ribbons.map(function (ribbon) {
	                var opacity = getOpacity(ribbon);
	
	                return _react2.default.createElement('path', _extends({
	                    key: ribbon.key,
	                    d: shapeGenerator(ribbon),
	                    fill: ribbon.source.color,
	                    fillOpacity: opacity,
	                    stroke: getBorderColor(_extends({}, ribbon, { color: ribbon.source.color })),
	                    strokeOpacity: opacity
	                }, commonProps(ribbon)));
	            })
	        );
	    }
	
	    var springConfig = {
	        damping: motionDamping,
	        stiffness: motionStiffness,
	        precision: 0.001
	    };
	
	    return _react2.default.createElement(
	        _reactMotion.TransitionMotion,
	        {
	            willEnter: ribbonWillEnter,
	            willLeave: ribbonWillLeave(springConfig),
	            styles: ribbons.map(function (ribbon) {
	                return {
	                    key: ribbon.key,
	                    data: ribbon,
	                    style: _extends({}, getRibbonAngles(ribbon, false, springConfig), {
	                        opacity: (0, _reactMotion.spring)(getOpacity(ribbon), springConfig)
	                    }, (0, _core.colorMotionSpring)(ribbon.source.color, springConfig))
	                };
	            })
	        },
	        function (interpolatedStyles) {
	            return _react2.default.createElement(
	                'g',
	                null,
	                interpolatedStyles.map(function (_ref5) {
	                    var key = _ref5.key,
	                        style = _ref5.style,
	                        ribbon = _ref5.data;
	
	                    var color = (0, _core.getInterpolatedColor)(style);
	
	                    return _react2.default.createElement('path', _extends({
	                        key: key,
	                        d: shapeGenerator({
	                            source: {
	                                startAngle: style.sourceStartAngle,
	                                endAngle: Math.max(style.sourceEndAngle, style.sourceStartAngle)
	                            },
	                            target: {
	                                startAngle: style.targetStartAngle,
	                                endAngle: Math.max(style.targetEndAngle, style.targetStartAngle)
	                            }
	                        }),
	                        fill: color,
	                        fillOpacity: style.opacity,
	                        stroke: getBorderColor(_extends({}, ribbon, { color: color })),
	                        strokeOpacity: style.opacity
	                    }, commonProps(ribbon)));
	                })
	            );
	        }
	    );
	};
	
	ChordRibbons.propTypes = _extends({
	    ribbons: _propTypes2.default.array.isRequired,
	    shapeGenerator: _propTypes2.default.func.isRequired,
	    borderWidth: _propTypes2.default.number.isRequired,
	    getBorderColor: _propTypes2.default.func.isRequired,
	    getOpacity: _propTypes2.default.func.isRequired,
	    setCurrent: _propTypes2.default.func.isRequired,
	    theme: _propTypes2.default.object.isRequired,
	    showTooltip: _propTypes2.default.func.isRequired,
	    hideTooltip: _propTypes2.default.func.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	}, _core.motionPropTypes);
	
	var enhance = (0, _compose2.default)((0, _withPropsOnChange2.default)(['tooltipFormat'], function (_ref6) {
	    var tooltipFormat = _ref6.tooltipFormat;
	
	    if (!tooltipFormat || (0, _lodash.isFunction)(tooltipFormat)) return { tooltipFormat: tooltipFormat };
	    return { tooltipFormat: (0, _d3Format.format)(tooltipFormat) };
	}), _pure2.default);
	
	exports.default = enhance(ChordRibbons);

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(5);
	
	var _Chord = __webpack_require__(211);
	
	var _Chord2 = _interopRequireDefault(_Chord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveChord = function ResponsiveChord(props) {
	    return _react2.default.createElement(
	        _core.ResponsiveWrapper,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_Chord2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveChord;

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
	                                                                                                                                                                                                                                                                   * This file is part of the nivo project.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Copyright 2016-present, Raphaël Benitte.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * For the full copyright and license information, please view the LICENSE
	                                                                                                                                                                                                                                                                   * file that was distributed with this source code.
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(5);
	
	var _ChordCanvas = __webpack_require__(213);
	
	var _ChordCanvas2 = _interopRequireDefault(_ChordCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResponsiveChordCanvas = function ResponsiveChordCanvas(props) {
	    return _react2.default.createElement(
	        _core.ResponsiveWrapper,
	        null,
	        function (_ref) {
	            var width = _ref.width,
	                height = _ref.height;
	            return _react2.default.createElement(_ChordCanvas2.default, _extends({ width: width, height: height }, props));
	        }
	    );
	};
	
	exports.default = ResponsiveChordCanvas;

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _compose = __webpack_require__(12);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _defaultProps = __webpack_require__(36);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _withState = __webpack_require__(907);
	
	var _withState2 = _interopRequireDefault(_withState);
	
	var _withPropsOnChange = __webpack_require__(15);
	
	var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);
	
	var _pure = __webpack_require__(7);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _d3Shape = __webpack_require__(58);
	
	var _d3Chord = __webpack_require__(563);
	
	var _core = __webpack_require__(5);
	
	var _props = __webpack_require__(88);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (Component) {
	    return (0, _compose2.default)((0, _defaultProps2.default)(_props.ChordDefaultProps), (0, _withState2.default)('currentArc', 'setCurrentArc', null), (0, _withState2.default)('currentRibbon', 'setCurrentRibbon', null), (0, _core.withMotion)(), (0, _core.withTheme)(), (0, _core.withDimensions)(), (0, _withPropsOnChange2.default)(['label'], function (_ref) {
	        var label = _ref.label;
	        return {
	            getLabel: (0, _core.getLabelGenerator)(label)
	        };
	    }), (0, _withPropsOnChange2.default)(['padAngle'], function (_ref2) {
	        var padAngle = _ref2.padAngle;
	        return {
	            chord: (0, _d3Chord.chord)().padAngle(padAngle)
	        };
	    }), (0, _withPropsOnChange2.default)(['labelTextColor'], function (_ref3) {
	        var labelTextColor = _ref3.labelTextColor;
	        return {
	            getLabelTextColor: (0, _core.getInheritedColorGenerator)(labelTextColor, 'labels.textColor')
	        };
	    }), (0, _withPropsOnChange2.default)(['colors', 'keys'], function (_ref4) {
	        var colors = _ref4.colors,
	            keys = _ref4.keys;
	
	        var color = (0, _core.getColorRange)(colors);
	
	        return {
	            colorById: keys.reduce(function (acc, key) {
	                acc[key] = color(key);
	                return acc;
	            }, {})
	        };
	    }), (0, _withPropsOnChange2.default)(['width', 'height', 'innerRadiusRatio', 'innerRadiusOffset'], function (_ref5) {
	        var width = _ref5.width,
	            height = _ref5.height,
	            innerRadiusRatio = _ref5.innerRadiusRatio,
	            innerRadiusOffset = _ref5.innerRadiusOffset;
	
	        var radius = Math.min(width, height) / 2;
	        var innerRadius = radius * innerRadiusRatio;
	        var ribbonRadius = radius * (innerRadiusRatio - innerRadiusOffset);
	
	        var arcGenerator = (0, _d3Shape.arc)().outerRadius(radius).innerRadius(innerRadius);
	        var ribbonGenerator = (0, _d3Chord.ribbon)().radius(ribbonRadius);
	
	        return { radius: radius, innerRadius: innerRadius, arcGenerator: arcGenerator, ribbonGenerator: ribbonGenerator };
	    }), (0, _withPropsOnChange2.default)(['arcOpacity', 'ribbonOpacity'], function (_ref6) {
	        var arcOpacity = _ref6.arcOpacity,
	            ribbonOpacity = _ref6.ribbonOpacity;
	        return {
	            getArcOpacity: function getArcOpacity() {
	                return arcOpacity;
	            },
	            getRibbonOpacity: function getRibbonOpacity() {
	                return ribbonOpacity;
	            }
	        };
	    }), (0, _withPropsOnChange2.default)(['isInteractive', 'currentArc', 'arcHoverOpacity', 'arcHoverOthersOpacity', 'currentRibbon', 'ribbonHoverOpacity', 'ribbonHoverOthersOpacity'], function (_ref7) {
	        var isInteractive = _ref7.isInteractive,
	            currentArc = _ref7.currentArc,
	            arcHoverOpacity = _ref7.arcHoverOpacity,
	            arcHoverOthersOpacity = _ref7.arcHoverOthersOpacity,
	            currentRibbon = _ref7.currentRibbon,
	            ribbonHoverOpacity = _ref7.ribbonHoverOpacity,
	            ribbonHoverOthersOpacity = _ref7.ribbonHoverOthersOpacity;
	
	        if (!isInteractive || !currentArc && !currentRibbon) return null;
	
	        var getArcOpacity = void 0;
	        var getRibbonOpacity = void 0;
	        if (isInteractive) {
	            if (currentArc) {
	                getArcOpacity = function getArcOpacity(arc) {
	                    if (arc.id === currentArc.id) return arcHoverOpacity;
	                    return arcHoverOthersOpacity;
	                };
	                getRibbonOpacity = function getRibbonOpacity(ribbon) {
	                    if (ribbon.source.id === currentArc.id || ribbon.target.id === currentArc.id) return ribbonHoverOpacity;
	                    return ribbonHoverOthersOpacity;
	                };
	            } else if (currentRibbon) {
	                getArcOpacity = function getArcOpacity(arc) {
	                    if (arc.id === currentRibbon.source.id || arc.id === currentRibbon.target.id) return arcHoverOpacity;
	                    return arcHoverOthersOpacity;
	                };
	                getRibbonOpacity = function getRibbonOpacity(ribbon) {
	                    if (ribbon.source.id === currentRibbon.source.id && ribbon.target.id === currentRibbon.target.id) return ribbonHoverOpacity;
	                    return ribbonHoverOthersOpacity;
	                };
	            }
	        }
	
	        return { getArcOpacity: getArcOpacity, getRibbonOpacity: getRibbonOpacity };
	    }), (0, _withPropsOnChange2.default)(['chord', 'colorById', 'matrix', 'keys'], function (_ref8) {
	        var chord = _ref8.chord,
	            colorById = _ref8.colorById,
	            matrix = _ref8.matrix,
	            keys = _ref8.keys;
	
	        var ribbons = chord(matrix);
	        ribbons.forEach(function (ribbon) {
	            ribbon.source.id = keys[ribbon.source.index];
	            ribbon.source.color = colorById[ribbon.source.id];
	            ribbon.target.id = keys[ribbon.target.index];
	            ribbon.target.color = colorById[ribbon.target.id];
	            var ribbonKeys = [ribbon.source.id, ribbon.target.id];
	            ribbonKeys.sort();
	            ribbon.key = ribbonKeys.sort().join('.');
	        });
	
	        var arcs = ribbons.groups.map(function (arc) {
	            arc.key = arc.id = keys[arc.index];
	            arc.color = colorById[arc.id];
	            return arc;
	        });
	
	        return { ribbons: ribbons, arcs: arcs };
	    }), (0, _withPropsOnChange2.default)(['arcBorderColor'], function (_ref9) {
	        var arcBorderColor = _ref9.arcBorderColor;
	        return {
	            getArcBorderColor: (0, _core.getInheritedColorGenerator)(arcBorderColor)
	        };
	    }), (0, _withPropsOnChange2.default)(['ribbonBorderColor'], function (_ref10) {
	        var ribbonBorderColor = _ref10.ribbonBorderColor;
	        return {
	            getRibbonBorderColor: (0, _core.getInheritedColorGenerator)(ribbonBorderColor)
	        };
	    }), _pure2.default)(Component);
	}; /*
	    * This file is part of the nivo project.
	    *
	    * Copyright 2016-present, Raphaël Benitte.
	    *
	    * For the full copyright and license information, please view the LICENSE
	    * file that was distributed with this source code.
	    */

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Chord = __webpack_require__(211);
	
	Object.defineProperty(exports, 'Chord', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chord).default;
	  }
	});
	
	var _ChordCanvas = __webpack_require__(213);
	
	Object.defineProperty(exports, 'ChordCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ChordCanvas).default;
	  }
	});
	
	var _ResponsiveChord = __webpack_require__(341);
	
	Object.defineProperty(exports, 'ResponsiveChord', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveChord).default;
	  }
	});
	
	var _ResponsiveChordCanvas = __webpack_require__(342);
	
	Object.defineProperty(exports, 'ResponsiveChordCanvas', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ResponsiveChordCanvas).default;
	  }
	});
	
	var _props = __webpack_require__(88);
	
	Object.keys(_props).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _props[key];
	    }
	  });
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.ChordDefaultProps = exports.ChordPropTypes = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _legends = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 * This file is part of the nivo project.
	 *
	 * Copyright 2016-present, Raphaël Benitte.
	 *
	 * For the full copyright and license information, please view the LICENSE
	 * file that was distributed with this source code.
	 */
	var ChordPropTypes = exports.ChordPropTypes = {
	    matrix: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.number)).isRequired,
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	
	    padAngle: _propTypes2.default.number.isRequired,
	    innerRadiusRatio: _propTypes2.default.number.isRequired,
	    innerRadiusOffset: _propTypes2.default.number.isRequired,
	
	    // arcs
	    arcOpacity: _propTypes2.default.number.isRequired,
	    arcBorderWidth: _propTypes2.default.number.isRequired,
	    arcBorderColor: _propTypes2.default.any.isRequired,
	    getArcBorderColor: _propTypes2.default.func.isRequired,
	
	    // ribbons
	    ribbonOpacity: _propTypes2.default.number.isRequired,
	    ribbonBorderWidth: _propTypes2.default.number.isRequired,
	    ribbonBorderColor: _propTypes2.default.any.isRequired,
	    getRibbonBorderColor: _propTypes2.default.func.isRequired,
	
	    // labels
	    enableLabel: _propTypes2.default.bool.isRequired,
	    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getLabel: _propTypes2.default.func.isRequired, // computed
	    labelOffset: _propTypes2.default.number.isRequired,
	    labelRotation: _propTypes2.default.number.isRequired,
	    labelTextColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
	    getLabelTextColor: _propTypes2.default.func.isRequired, // computed
	
	    // colors
	    colors: _propTypes2.default.any.isRequired,
	
	    // interactivity
	    isInteractive: _propTypes2.default.bool.isRequired,
	    arcHoverOpacity: _propTypes2.default.number.isRequired,
	    arcHoverOthersOpacity: _propTypes2.default.number.isRequired,
	    ribbonHoverOpacity: _propTypes2.default.number.isRequired,
	    ribbonHoverOthersOpacity: _propTypes2.default.number.isRequired,
	    tooltipFormat: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	
	    // canvas specific
	    pixelRatio: _propTypes2.default.number.isRequired,
	
	    legends: _propTypes2.default.arrayOf(_propTypes2.default.shape(_legends.LegendPropShape)).isRequired
	};
	
	var ChordDefaultProps = exports.ChordDefaultProps = {
	    padAngle: 0,
	    innerRadiusRatio: 0.9,
	    innerRadiusOffset: 0,
	
	    // arcs
	    arcOpacity: 1,
	    arcBorderWidth: 1,
	    arcBorderColor: 'inherit:darker(0.4)',
	
	    // ribbons
	    ribbonOpacity: 0.5,
	    ribbonBorderWidth: 1,
	    ribbonBorderColor: 'inherit:darker(0.4)',
	
	    // labels
	    enableLabel: true,
	    label: 'id',
	    labelOffset: 12,
	    labelRotation: 0,
	    labelTextColor: 'inherit:darker(1)',
	
	    // colors
	    colors: 'nivo',
	
	    // interactivity
	    isInteractive: true,
	    arcHoverOpacity: 1,
	    arcHoverOthersOpacity: 0.15,
	    ribbonHoverOpacity: 0.85,
	    ribbonHoverOthersOpacity: 0.15,
	
	    // canvas specific
	    pixelRatio: global.window && global.window.devicePixelRatio ? global.window.devicePixelRatio : 1,
	
	    legends: []
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-chord/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(267), __webpack_require__(268)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Path) { 'use strict';
	
	var cos = Math.cos;
	var sin = Math.sin;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = pi * 2;
	var max = Math.max;
	
	function compareValue(compare) {
	  return function(a, b) {
	    return compare(
	      a.source.value + a.target.value,
	      b.source.value + b.target.value
	    );
	  };
	}
	
	var chord = function() {
	  var padAngle = 0,
	      sortGroups = null,
	      sortSubgroups = null,
	      sortChords = null;
	
	  function chord(matrix) {
	    var n = matrix.length,
	        groupSums = [],
	        groupIndex = d3Array.range(n),
	        subgroupIndex = [],
	        chords = [],
	        groups = chords.groups = new Array(n),
	        subgroups = new Array(n * n),
	        k,
	        x,
	        x0,
	        dx,
	        i,
	        j;
	
	    // Compute the sum.
	    k = 0, i = -1; while (++i < n) {
	      x = 0, j = -1; while (++j < n) {
	        x += matrix[i][j];
	      }
	      groupSums.push(x);
	      subgroupIndex.push(d3Array.range(n));
	      k += x;
	    }
	
	    // Sort groups…
	    if (sortGroups) groupIndex.sort(function(a, b) {
	      return sortGroups(groupSums[a], groupSums[b]);
	    });
	
	    // Sort subgroups…
	    if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
	      d.sort(function(a, b) {
	        return sortSubgroups(matrix[i][a], matrix[i][b]);
	      });
	    });
	
	    // Convert the sum to scaling factor for [0, 2pi].
	    // TODO Allow start and end angle to be specified?
	    // TODO Allow padding to be specified as percentage?
	    k = max(0, tau - padAngle * n) / k;
	    dx = k ? padAngle : tau / n;
	
	    // Compute the start and end angle for each group and subgroup.
	    // Note: Opera has a bug reordering object literal properties!
	    x = 0, i = -1; while (++i < n) {
	      x0 = x, j = -1; while (++j < n) {
	        var di = groupIndex[i],
	            dj = subgroupIndex[di][j],
	            v = matrix[di][dj],
	            a0 = x,
	            a1 = x += v * k;
	        subgroups[dj * n + di] = {
	          index: di,
	          subindex: dj,
	          startAngle: a0,
	          endAngle: a1,
	          value: v
	        };
	      }
	      groups[di] = {
	        index: di,
	        startAngle: x0,
	        endAngle: x,
	        value: groupSums[di]
	      };
	      x += dx;
	    }
	
	    // Generate chords for each (non-empty) subgroup-subgroup link.
	    i = -1; while (++i < n) {
	      j = i - 1; while (++j < n) {
	        var source = subgroups[j * n + i],
	            target = subgroups[i * n + j];
	        if (source.value || target.value) {
	          chords.push(source.value < target.value
	              ? {source: target, target: source}
	              : {source: source, target: target});
	        }
	      }
	    }
	
	    return sortChords ? chords.sort(sortChords) : chords;
	  }
	
	  chord.padAngle = function(_) {
	    return arguments.length ? (padAngle = max(0, _), chord) : padAngle;
	  };
	
	  chord.sortGroups = function(_) {
	    return arguments.length ? (sortGroups = _, chord) : sortGroups;
	  };
	
	  chord.sortSubgroups = function(_) {
	    return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
	  };
	
	  chord.sortChords = function(_) {
	    return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
	  };
	
	  return chord;
	};
	
	var slice = Array.prototype.slice;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultSource(d) {
	  return d.source;
	}
	
	function defaultTarget(d) {
	  return d.target;
	}
	
	function defaultRadius(d) {
	  return d.radius;
	}
	
	function defaultStartAngle(d) {
	  return d.startAngle;
	}
	
	function defaultEndAngle(d) {
	  return d.endAngle;
	}
	
	var ribbon = function() {
	  var source = defaultSource,
	      target = defaultTarget,
	      radius = defaultRadius,
	      startAngle = defaultStartAngle,
	      endAngle = defaultEndAngle,
	      context = null;
	
	  function ribbon() {
	    var buffer,
	        argv = slice.call(arguments),
	        s = source.apply(this, argv),
	        t = target.apply(this, argv),
	        sr = +radius.apply(this, (argv[0] = s, argv)),
	        sa0 = startAngle.apply(this, argv) - halfPi,
	        sa1 = endAngle.apply(this, argv) - halfPi,
	        sx0 = sr * cos(sa0),
	        sy0 = sr * sin(sa0),
	        tr = +radius.apply(this, (argv[0] = t, argv)),
	        ta0 = startAngle.apply(this, argv) - halfPi,
	        ta1 = endAngle.apply(this, argv) - halfPi;
	
	    if (!context) context = buffer = d3Path.path();
	
	    context.moveTo(sx0, sy0);
	    context.arc(0, 0, sr, sa0, sa1);
	    if (sa0 !== ta0 || sa1 !== ta1) { // TODO sr !== tr?
	      context.quadraticCurveTo(0, 0, tr * cos(ta0), tr * sin(ta0));
	      context.arc(0, 0, tr, ta0, ta1);
	    }
	    context.quadraticCurveTo(0, 0, sx0, sy0);
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  ribbon.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), ribbon) : radius;
	  };
	
	  ribbon.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), ribbon) : startAngle;
	  };
	
	  ribbon.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), ribbon) : endAngle;
	  };
	
	  ribbon.source = function(_) {
	    return arguments.length ? (source = _, ribbon) : source;
	  };
	
	  ribbon.target = function(_) {
	    return arguments.length ? (target = _, ribbon) : target;
	  };
	
	  ribbon.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), ribbon) : context;
	  };
	
	  return ribbon;
	};
	
	exports.chord = chord;
	exports.ribbon = ribbon;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(173);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ }),

/***/ 169:
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(43),
	    isObjectLike = __webpack_require__(35);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/**
	 * The base implementation of `_.isRegExp` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 */
	function baseIsRegExp(value) {
	  return isObjectLike(value) && baseGetTag(value) == regexpTag;
	}
	
	module.exports = baseIsRegExp;


/***/ }),

/***/ 174:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(174);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	var asciiSize = __webpack_require__(168),
	    hasUnicode = __webpack_require__(45),
	    unicodeSize = __webpack_require__(185);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(169),
	    hasUnicode = __webpack_require__(45),
	    unicodeToArray = __webpack_require__(186);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),

/***/ 185:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    ++result;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ }),

/***/ 186:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	var baseIsRegExp = __webpack_require__(172),
	    baseUnary = __webpack_require__(82),
	    nodeUtil = __webpack_require__(182);
	
	/* Node.js helper references. */
	var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	module.exports = isRegExp;


/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(176),
	    castSlice = __webpack_require__(177),
	    hasUnicode = __webpack_require__(45),
	    isObject = __webpack_require__(18),
	    isRegExp = __webpack_require__(190),
	    stringSize = __webpack_require__(183),
	    stringToArray = __webpack_require__(184),
	    toInteger = __webpack_require__(192),
	    toString = __webpack_require__(193);
	
	/** Used as default options for `_.truncate`. */
	var DEFAULT_TRUNC_LENGTH = 30,
	    DEFAULT_TRUNC_OMISSION = '...';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Truncates `string` if it's longer than the given maximum string length.
	 * The last characters of the truncated string are replaced with the omission
	 * string which defaults to "...".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to truncate.
	 * @param {Object} [options={}] The options object.
	 * @param {number} [options.length=30] The maximum string length.
	 * @param {string} [options.omission='...'] The string to indicate text is omitted.
	 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	 * @returns {string} Returns the truncated string.
	 * @example
	 *
	 * _.truncate('hi-diddly-ho there, neighborino');
	 * // => 'hi-diddly-ho there, neighbo...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': ' '
	 * });
	 * // => 'hi-diddly-ho there,...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': /,? +/
	 * });
	 * // => 'hi-diddly-ho there...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'omission': ' [...]'
	 * });
	 * // => 'hi-diddly-ho there, neig [...]'
	 */
	function truncate(string, options) {
	  var length = DEFAULT_TRUNC_LENGTH,
	      omission = DEFAULT_TRUNC_OMISSION;
	
	  if (isObject(options)) {
	    var separator = 'separator' in options ? options.separator : separator;
	    length = 'length' in options ? toInteger(options.length) : length;
	    omission = 'omission' in options ? baseToString(options.omission) : omission;
	  }
	  string = toString(string);
	
	  var strLength = string.length;
	  if (hasUnicode(string)) {
	    var strSymbols = stringToArray(string);
	    strLength = strSymbols.length;
	  }
	  if (length >= strLength) {
	    return string;
	  }
	  var end = length - stringSize(omission);
	  if (end < 1) {
	    return omission;
	  }
	  var result = strSymbols
	    ? castSlice(strSymbols, 0, end).join('')
	    : string.slice(0, end);
	
	  if (separator === undefined) {
	    return result + omission;
	  }
	  if (strSymbols) {
	    end += (result.length - end);
	  }
	  if (isRegExp(separator)) {
	    if (string.slice(end).search(separator)) {
	      var match,
	          substring = result;
	
	      if (!separator.global) {
	        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	      }
	      separator.lastIndex = 0;
	      while ((match = separator.exec(substring))) {
	        var newEnd = match.index;
	      }
	      result = result.slice(0, newEnd === undefined ? end : newEnd);
	    }
	  } else if (string.indexOf(baseToString(separator), end) != end) {
	    var index = result.lastIndexOf(separator);
	    if (index > -1) {
	      result = result.slice(0, index);
	    }
	  }
	  return result + omission;
	}
	
	module.exports = truncate;


/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(24);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(37);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var withState = function withState(stateName, stateUpdaterName, initialState) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	
	    var WithState = function (_Component) {
	      _inherits(WithState, _Component);
	
	      function WithState() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, WithState);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
	        }, _this.updateStateValue = function (updateFn, callback) {
	          return _this.setState(function (_ref) {
	            var stateValue = _ref.stateValue;
	            return {
	              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
	            };
	          }, callback);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      WithState.prototype.render = function render() {
	        var _extends2;
	
	        return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
	      };
	
	      return WithState;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withState'))(WithState);
	    }
	    return WithState;
	  };
	};
	
	exports.default = withState;

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _truncate = __webpack_require__(194);
	
	var _truncate2 = _interopRequireDefault(_truncate);
	
	var _chord = __webpack_require__(343);
	
	var _nivoTheme = __webpack_require__(20);
	
	var _nivoTheme2 = _interopRequireDefault(_nivoTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AffinityChord = function (_Component) {
	    _inherits(AffinityChord, _Component);
	
	    function AffinityChord() {
	        _classCallCheck(this, AffinityChord);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    AffinityChord.prototype.render = function render() {
	        var _props = this.props,
	            keys = _props.keys,
	            matrix = _props.matrix,
	            colors = _props.colors;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'chart-wrapper', style: { height: '800px' } },
	            _react2.default.createElement(_chord.ResponsiveChord, {
	                margin: {
	                    top: 100,
	                    right: 80,
	                    bottom: 100,
	                    left: 80
	                },
	                colors: colors,
	                padAngle: 0.02,
	                innerRadiusOffset: 0.02,
	                keys: keys,
	                matrix: matrix,
	                labelRotation: -90,
	                ribbonHoverOthersOpacity: 0,
	                label: function label(d) {
	                    return (0, _truncate2.default)(d.id, { length: 10 });
	                },
	                animate: false,
	                theme: _nivoTheme2.default
	            })
	        );
	    };
	
	    return AffinityChord;
	}(_react.Component);
	
	AffinityChord.propTypes = {
	    keys: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	    matrix: _propTypes2.default.arrayOf(_propTypes2.default.array).isRequired
	};
	exports.default = AffinityChord;
	module.exports = exports['default'];

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(41);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AffinityToggle = function (_Component) {
	    _inherits(AffinityToggle, _Component);
	
	    function AffinityToggle() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, AffinityToggle);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleOptionClick = function (e) {
	            _this.props.onChange(e.target.value);
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    AffinityToggle.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            sections = _props.sections,
	            selectedSections = _props.selectedSections,
	            maxNumberOfSections = _props.maxNumberOfSections;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'chord__toggle' },
	            sections.map(function (section) {
	                var isChecked = selectedSections.includes(section.id);
	                var isDisabled = !isChecked && selectedSections.length >= maxNumberOfSections;
	
	                return _react2.default.createElement(
	                    'label',
	                    {
	                        htmlFor: section.id + '__check',
	                        key: section.id,
	                        className: (0, _classnames2.default)('chord__toggle__item', {
	                            'chord__toggle__item--is-disabled': isDisabled
	                        })
	                    },
	                    _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        id: section.id + '__check',
	                        value: section.id,
	                        checked: isChecked,
	                        onChange: _this2.handleOptionClick,
	                        disabled: isDisabled
	                    }),
	                    section.label
	                );
	            })
	        );
	    };
	
	    return AffinityToggle;
	}(_react.Component);
	
	AffinityToggle.propTypes = {
	    sections: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        id: _propTypes2.default.string.isRequired,
	        label: _propTypes2.default.string.isRequired
	    })).isRequired,
	    selectedSections: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    maxNumberOfSections: _propTypes2.default.number.isRequired
	};
	exports.default = AffinityToggle;
	module.exports = exports['default'];

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

	module.exports = {"chord":{"keys":["React","Angular","Angular 2","Ember","Vue","Backbone","Polymer","Aurelia","No Front-End Framework","\"Plain\" JavaScript (ES5)","ES6","TypeScript","Flow","Elm","ClojureScript","Reason","REST API","Redux","MobX","GraphQL","Relay/Relay Modern","Falcor","Apollo","Firebase","Plain CSS","SASS/SCSS","Stylus","LESS","CSS-in-JS","Bootstrap","Foundation","Meteor","Express","Koa","Hapi","FeathersJS","Sails","Loopback","Keystone","Mocha","Jasmine","Enzyme","Jest","Tape","Ava","Webpack","Grunt","Gulp","Browserify","NPM","Rollup","Native Apps","React Native","Ionic","PhoneGap/Cordova","NativeScript","Electron"],"matrix":[[0,1990,1905,661,2280,1011,613,153,5313,6588,13162,4356,2227,938,446,117,12382,9671,1062,2361,496,59,1127,3705,9410,10809,1579,4366,5432,7783,2523,1102,9896,1762,1189,321,381,285,234,7507,5869,4480,5435,1210,940,11922,2541,6229,3269,12896,1372,4779,4401,1086,1517,207,3306],[1990,0,2026,186,811,351,283,52,1785,2960,3971,2316,253,116,59,15,4317,1558,145,341,52,16,125,1299,3515,3862,421,1893,884,3529,1090,319,3043,329,288,64,185,144,60,2172,2567,507,688,182,136,2999,1661,3007,1285,4396,309,1733,668,1153,1149,196,925],[1905,2026,0,186,746,248,295,87,1529,2257,3997,3777,275,130,50,16,4140,1795,166,412,71,21,190,1389,3090,3785,394,1530,917,3168,909,305,2896,345,312,75,175,143,62,2090,2539,483,716,185,139,3442,1212,2591,1043,4231,439,1673,694,1350,1135,319,972],[661,186,186,0,260,146,86,25,466,622,1067,389,133,97,46,12,1048,500,60,160,34,9,63,374,790,993,152,364,288,716,347,121,766,170,144,39,81,38,23,701,572,247,308,97,62,729,310,593,389,1044,180,474,272,127,201,26,328],[2280,811,746,260,0,376,286,103,2032,2608,4317,1445,408,220,90,21,4210,1910,282,590,84,15,253,1310,3333,3834,725,1409,1346,2792,1042,423,3001,562,380,179,189,117,74,2117,1674,555,912,327,340,3767,912,2522,1191,4353,562,1574,879,571,838,136,1335],[1011,351,248,146,376,0,140,20,950,1202,1523,473,155,89,50,11,1591,776,78,216,48,9,71,396,1330,1460,247,738,440,1133,456,151,1177,171,153,46,85,49,32,990,931,340,409,153,83,1187,678,1051,627,1612,169,694,326,170,345,33,402],[613,283,295,86,286,140,0,47,636,696,1118,503,117,79,44,13,1112,575,73,209,41,8,78,500,978,906,154,426,360,617,229,118,849,159,107,33,68,54,29,735,616,196,277,106,91,824,347,745,358,1121,174,485,238,194,273,43,381],[153,52,87,25,103,20,47,0,146,148,313,215,32,24,11,6,313,136,34,49,10,4,20,82,242,262,42,135,79,248,80,35,221,50,41,19,25,15,8,171,180,37,73,24,19,246,77,220,75,327,39,118,53,55,72,14,122],[5313,1785,1529,466,2032,950,636,146,0,6161,8387,2985,908,558,242,52,8393,4061,426,1101,213,36,426,2316,7625,7297,1053,3022,2574,5249,1857,649,6072,974,678,164,262,186,143,4507,3812,1698,2237,781,551,6364,2255,4900,2466,8663,1015,3509,1741,908,1597,195,2197],[6588,2960,2257,622,2608,1202,696,148,6161,0,10943,3701,909,506,248,57,11021,4841,466,1196,213,35,474,2939,10430,9642,1249,4263,3070,7930,2525,909,7713,973,796,207,365,249,176,5515,4912,1901,2480,804,522,8064,3393,6685,3232,11518,937,4494,2210,1407,2071,275,2501],[13162,3971,3997,1067,4317,1523,1118,313,8387,10943,0,7248,2350,1090,461,117,18482,10452,1099,2677,508,72,1237,5177,14548,16075,2217,6547,6186,12237,3769,1509,13722,2145,1518,432,596,437,292,10191,8595,4510,5743,1472,1155,15658,4288,10007,4821,19253,1960,7023,4592,2171,2962,453,4662],[4356,2316,3777,389,1445,473,503,215,2985,3701,7248,0,919,480,199,57,7330,3705,534,1024,207,46,466,2184,5419,6419,783,2754,2113,5157,1517,506,5232,874,616,153,269,205,111,4077,4085,1448,2040,514,434,6191,1756,4099,1772,7438,919,3009,1587,1546,1538,379,2013],[2227,253,275,133,408,155,117,32,908,909,2350,919,0,358,141,77,2139,1952,264,772,243,27,381,725,1542,1770,345,737,1342,1191,459,179,1886,604,323,80,77,63,58,1430,1104,1242,1599,343,325,2209,327,936,534,2213,452,1008,1153,171,224,48,816],[938,116,130,97,220,89,79,24,558,506,1090,480,358,0,186,56,1110,828,89,322,65,22,141,332,848,906,178,388,526,684,253,92,799,228,168,40,47,33,23,717,586,445,563,225,156,1007,165,463,298,1087,208,466,425,77,118,27,384],[446,59,50,46,90,50,44,11,242,248,461,199,141,186,0,39,478,338,46,141,44,20,56,128,371,378,93,193,235,296,125,39,330,112,73,18,22,15,15,301,248,158,201,93,55,394,94,203,155,455,79,224,188,40,54,10,177],[117,15,16,12,21,11,13,6,52,57,117,57,77,56,39,0,110,91,17,64,26,7,35,39,83,79,18,37,94,63,33,12,96,46,31,9,8,3,7,66,56,62,90,33,24,109,20,38,45,114,40,74,80,11,11,5,61],[12382,4317,4140,1048,4210,1591,1112,313,8393,11021,18482,7330,2139,1110,478,110,0,9912,1042,2373,433,62,1005,5088,14697,15972,2122,6665,5827,12590,3792,1430,13459,2026,1488,416,597,432,285,10015,8654,4223,5368,1412,1064,15048,4406,9981,4734,19025,1862,7214,4351,2265,3080,471,4523],[9671,1558,1795,500,1910,776,575,136,4061,4841,10452,3705,1952,828,338,91,9912,0,684,2037,419,61,996,3041,7286,8581,1328,3430,4498,6003,1944,814,7988,1558,1044,277,328,273,182,6255,4976,3964,4716,1076,816,9771,1858,4824,2466,10156,1234,3776,3586,962,1243,218,2737],[1062,145,166,60,282,78,73,34,426,466,1099,534,264,89,46,17,1042,684,0,312,75,16,158,377,726,880,184,391,584,629,216,109,892,265,157,80,47,56,38,691,517,470,585,150,154,1076,148,461,217,1075,209,465,494,123,161,46,426],[2361,341,412,160,590,216,209,49,1101,1196,2677,1024,772,322,141,64,2373,2037,312,0,483,47,1189,895,1869,2106,382,875,1410,1453,542,335,2223,622,384,109,101,93,78,1663,1268,1127,1465,352,332,2477,466,1167,605,2602,444,1170,1212,275,365,79,980],[496,52,71,34,84,48,41,10,213,213,508,207,243,65,44,26,433,419,75,483,0,24,180,182,331,378,89,162,321,260,111,50,426,156,85,21,21,29,18,306,265,270,360,77,76,480,93,216,127,485,122,261,322,50,69,26,228],[59,16,21,9,15,9,8,4,36,35,72,46,27,22,20,7,62,61,16,47,24,0,27,32,56,54,18,31,46,46,29,16,62,32,22,8,7,5,5,52,41,33,36,14,13,66,11,32,26,68,17,38,36,17,14,6,40],[1127,125,190,63,253,71,78,20,426,474,1237,466,381,141,56,35,1005,996,158,1189,180,27,0,412,804,927,168,365,722,632,222,217,1037,316,184,67,47,42,45,758,537,580,734,165,169,1153,163,462,223,1193,220,517,632,119,166,36,454],[3705,1299,1389,374,1310,396,500,82,2316,2939,5177,2184,725,332,128,39,5088,3041,377,895,182,32,412,0,4037,4498,751,1714,1956,3374,1274,534,4139,643,513,153,233,190,96,2858,2517,1251,1704,428,369,4395,1239,2953,1474,5252,603,2204,1669,996,1042,218,1514],[9410,3515,3090,790,3333,1330,978,242,7625,10430,14548,5419,1542,848,371,83,14697,7286,726,1869,331,56,804,4037,0,12494,1617,5400,4581,10563,3156,1169,10385,1489,1081,301,443,333,210,7562,6519,3067,3931,1098,814,11370,3842,7980,3840,15232,1414,5955,3233,1770,2560,370,3572],[10809,3862,3785,993,3834,1460,906,262,7297,9642,16075,6419,1770,906,378,79,15972,8581,880,2106,378,54,927,4498,12494,0,1955,6282,4899,11058,3792,1308,11337,1693,1276,354,532,385,243,8654,7760,3640,4561,1120,883,13298,4193,9539,4377,16612,1572,6112,3722,2163,2762,410,3800],[1579,421,394,152,725,247,154,42,1053,1249,2217,783,345,178,93,18,2122,1328,184,382,89,18,168,751,1617,1955,0,1146,880,1319,543,264,1771,407,269,99,117,80,63,1343,1092,563,747,243,226,1920,488,1292,720,2222,345,846,611,269,421,79,688],[4366,1893,1530,364,1409,738,426,135,3022,4263,6547,2754,737,388,193,37,6665,3430,391,875,162,31,365,1714,5400,6282,1146,0,2078,5095,1546,615,4817,739,575,176,264,180,116,3851,3483,1431,1792,469,336,5320,2259,3941,1985,6826,617,2735,1571,935,1294,205,1686],[5432,884,917,288,1346,440,360,79,2574,3070,6186,2113,1342,526,235,94,5827,4498,584,1410,321,46,722,1956,4581,4899,880,2078,0,3645,1236,560,4772,1026,664,206,201,166,141,3397,2674,2289,2888,703,596,5671,1083,2787,1546,6084,828,2536,2502,582,780,148,1867],[7783,3529,3168,716,2792,1133,617,248,5249,7930,12237,5157,1191,684,296,63,12590,6003,629,1453,260,46,632,3374,10563,11058,1319,5095,3645,0,3511,1077,8774,1172,921,278,436,324,180,6458,5840,2325,3017,710,533,9733,3494,7048,3312,12945,994,5030,2705,1823,2312,362,2878],[2523,1090,909,347,1042,456,229,80,1857,2525,3769,1517,459,253,125,33,3792,1944,216,542,111,29,222,1274,3156,3792,543,1546,1236,3511,0,434,2749,460,387,111,200,141,72,2117,1919,825,1086,294,231,3110,1227,2591,1292,3963,408,1591,940,653,822,133,987],[1102,319,305,121,423,151,118,35,649,909,1509,506,179,92,39,12,1430,814,109,335,50,16,217,534,1169,1308,264,615,560,1077,434,0,1253,177,139,80,90,58,39,846,667,336,447,111,85,1185,432,862,473,1547,148,622,497,259,369,62,465],[9896,3043,2896,766,3001,1177,849,221,6072,7713,13722,5232,1886,799,330,96,13459,7988,892,2223,426,62,1037,4139,10385,11337,1771,4817,4772,8774,2749,1253,0,1840,1293,402,554,411,277,8396,6648,3593,4583,1230,963,11480,3097,7285,3641,13971,1555,5126,3648,1722,2274,356,3856],[1762,329,345,170,562,171,159,50,974,973,2145,874,604,228,112,46,2026,1558,265,622,156,32,316,643,1489,1693,407,739,1026,1172,460,177,1840,0,532,107,116,61,72,1500,1052,855,1085,415,392,1933,315,999,564,2100,496,894,834,217,308,65,881],[1189,288,312,144,380,153,107,41,678,796,1518,616,323,168,73,31,1488,1044,157,384,85,22,184,513,1081,1276,269,575,664,921,387,139,1293,532,0,91,122,89,52,1081,853,543,714,301,235,1329,294,783,435,1511,284,637,554,191,254,60,590],[321,64,75,39,179,46,33,19,164,207,432,153,80,40,18,9,416,277,80,109,21,8,67,153,301,354,99,176,206,278,111,80,402,107,91,0,67,39,30,265,185,110,157,57,58,377,72,223,114,426,78,168,162,67,101,20,170],[381,185,175,81,189,85,68,25,262,365,596,269,77,47,22,8,597,328,47,101,21,7,47,233,443,532,117,264,201,436,200,90,554,116,122,67,0,76,46,390,341,130,182,52,49,478,209,400,215,609,90,275,173,143,156,36,224],[285,144,143,38,117,49,54,15,186,249,437,205,63,33,15,3,432,273,56,93,29,5,42,190,333,385,80,180,166,324,141,58,411,61,89,39,76,0,39,301,260,112,141,50,43,369,116,267,130,445,64,194,144,139,133,42,175],[234,60,62,23,74,32,29,8,143,176,292,111,58,23,15,7,285,182,38,78,18,5,45,96,210,243,63,116,141,180,72,39,277,72,52,30,46,39,0,191,147,91,119,36,35,260,62,168,104,290,55,132,126,51,64,14,110],[7507,2172,2090,701,2117,990,735,171,4507,5515,10191,4077,1430,717,301,66,10015,6255,691,1663,306,52,758,2858,7562,8654,1343,3851,3397,6458,2117,846,8396,1500,1081,265,390,301,191,0,6779,3255,3650,930,738,8667,2358,5426,2767,10241,1239,3891,2651,1212,1647,266,2865],[5869,2567,2539,572,1674,931,616,180,3812,4912,8595,4085,1104,586,248,56,8654,4976,517,1268,265,41,537,2517,6519,7760,1092,3483,2674,5840,1919,667,6648,1052,853,185,341,260,147,6779,0,2559,3073,647,487,7287,2395,5040,2414,8764,949,3368,2055,1299,1586,281,2209],[4480,507,483,247,555,340,196,37,1698,1901,4510,1448,1242,445,158,62,4223,3964,470,1127,270,33,580,1251,3067,3640,563,1431,2289,2325,825,336,3593,855,543,110,130,112,91,3255,2559,0,3450,651,515,4353,655,1803,988,4326,626,1601,1715,302,414,64,1282],[5435,688,716,308,912,409,277,73,2237,2480,5743,2040,1599,563,201,90,5368,4716,585,1465,360,36,734,1704,3931,4561,747,1792,2888,3017,1086,447,4583,1085,714,157,182,141,119,3650,3073,3450,0,768,620,5470,846,2392,1260,5514,872,2161,2271,429,604,98,1719],[1210,182,185,97,327,153,106,24,781,804,1472,514,343,225,93,33,1412,1076,150,352,77,14,165,428,1098,1120,243,469,703,710,294,111,1230,415,301,57,52,50,36,930,647,651,768,0,441,1270,177,631,550,1450,392,490,446,131,201,37,566],[940,136,139,62,340,83,91,19,551,522,1155,434,325,156,55,24,1064,816,154,332,76,13,169,369,814,883,226,336,596,533,231,85,963,392,235,58,49,43,35,738,487,515,620,441,0,1029,124,513,319,1122,358,431,399,110,144,32,498],[11922,2999,3442,729,3767,1187,824,246,6364,8064,15658,6191,2209,1007,394,109,15048,9771,1076,2477,480,66,1153,4395,11370,13298,1920,5320,5671,9733,3110,1185,11480,1933,1329,377,478,369,260,8667,7287,4353,5470,1270,1029,0,3286,7953,3866,15685,1681,5649,4151,1763,2262,390,3913],[2541,1661,1212,310,912,678,347,77,2255,3393,4288,1756,327,165,94,20,4406,1858,148,466,93,11,163,1239,3842,4193,488,2259,1083,3494,1227,432,3097,315,294,72,209,116,62,2358,2395,655,846,177,124,3286,0,3863,1768,4753,290,1936,913,746,1026,149,973],[6229,3007,2591,593,2522,1051,745,220,4900,6685,10007,4099,936,463,203,38,9981,4824,461,1167,216,32,462,2953,7980,9539,1292,3941,2787,7048,2591,862,7285,999,783,223,400,267,168,5426,5040,1803,2392,631,513,7953,3863,0,3795,10706,1030,3819,2129,1556,1920,309,2437],[3269,1285,1043,389,1191,627,358,75,2466,3232,4821,1772,534,298,155,45,4734,2466,217,605,127,26,223,1474,3840,4377,720,1985,1546,3312,1292,473,3641,564,435,114,215,130,104,2767,2414,988,1260,550,319,3866,1768,3795,0,5102,624,2011,1184,709,1011,143,1362],[12896,4396,4231,1044,4353,1612,1121,327,8663,11518,19253,7438,2213,1087,455,114,19025,10156,1075,2602,485,68,1193,5252,15232,16612,2222,6826,6084,12945,3963,1547,13971,2100,1511,426,609,445,290,10241,8764,4326,5514,1450,1122,15685,4753,10706,5102,0,1961,7244,4465,2337,3195,475,4693],[1372,309,439,180,562,169,174,39,1015,937,1960,919,452,208,79,40,1862,1234,209,444,122,17,220,603,1414,1572,345,617,828,994,408,148,1555,496,284,78,90,64,55,1239,949,626,872,392,358,1681,290,1030,624,1961,0,774,609,246,363,95,791],[4779,1733,1673,474,1574,694,485,118,3509,4494,7023,3009,1008,466,224,74,7214,3776,465,1170,261,38,517,2204,5955,6112,846,2735,2536,5030,1591,622,5126,894,637,168,275,194,132,3891,3368,1601,2161,490,431,5649,1936,3819,2011,7244,774,0,2726,1114,1509,302,2368],[4401,668,694,272,879,326,238,53,1741,2210,4592,1587,1153,425,188,80,4351,3586,494,1212,322,36,632,1669,3233,3722,611,1571,2502,2705,940,497,3648,834,554,162,173,144,126,2651,2055,1715,2271,446,399,4151,913,2129,1184,4465,609,2726,0,573,599,168,1686],[1086,1153,1350,127,571,170,194,55,908,1407,2171,1546,171,77,40,11,2265,962,123,275,50,17,119,996,1770,2163,269,935,582,1823,653,259,1722,217,191,67,143,139,51,1212,1299,302,429,131,110,1763,746,1556,709,2337,246,1114,573,0,1534,197,770],[1517,1149,1135,201,838,345,273,72,1597,2071,2962,1538,224,118,54,11,3080,1243,161,365,69,14,166,1042,2560,2762,421,1294,780,2312,822,369,2274,308,254,101,156,133,64,1647,1586,414,604,201,144,2262,1026,1920,1011,3195,363,1509,599,1534,0,209,1066],[207,196,319,26,136,33,43,14,195,275,453,379,48,27,10,5,471,218,46,79,26,6,36,218,370,410,79,205,148,362,133,62,356,65,60,20,36,42,14,266,281,64,98,37,32,390,149,309,143,475,95,302,168,197,209,0,224],[3306,925,972,328,1335,402,381,122,2197,2501,4662,2013,816,384,177,61,4523,2737,426,980,228,40,454,1514,3572,3800,688,1686,1867,2878,987,465,3856,881,590,170,224,175,110,2865,2209,1282,1719,566,498,3913,973,2437,1362,4693,791,2368,1686,770,1066,224,0]]}}

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _backend = __webpack_require__(76);
	
	var _backend2 = _interopRequireDefault(_backend);
	
	var _build = __webpack_require__(77);
	
	var _build2 = _interopRequireDefault(_build);
	
	var _style = __webpack_require__(80);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _flavor = __webpack_require__(109);
	
	var _flavor2 = _interopRequireDefault(_flavor);
	
	var _frontend = __webpack_require__(61);
	
	var _frontend2 = _interopRequireDefault(_frontend);
	
	var _mobile = __webpack_require__(78);
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	var _state = __webpack_require__(79);
	
	var _state2 = _interopRequireDefault(_state);
	
	var _testing = __webpack_require__(81);
	
	var _testing2 = _interopRequireDefault(_testing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var keysBySection = {
	    backend: _backend2.default.keys,
	    build: _build2.default.keys,
	    style: _style2.default.keys,
	    flavors: _flavor2.default.keys,
	    frontend: _frontend2.default.keys,
	    mobile: _mobile2.default.keys,
	    state: _state2.default.keys,
	    testing: _testing2.default.keys
	};
	
	exports.default = keysBySection;
	module.exports = exports['default'];

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AffinityChord = __webpack_require__(422);
	
	var _AffinityChord2 = _interopRequireDefault(_AffinityChord);
	
	var _AffinityToggle = __webpack_require__(423);
	
	var _AffinityToggle2 = _interopRequireDefault(_AffinityToggle);
	
	var _allToolsPairing = __webpack_require__(746);
	
	var _allToolsPairing2 = _interopRequireDefault(_allToolsPairing);
	
	var _keysBySection = __webpack_require__(447);
	
	var _keysBySection2 = _interopRequireDefault(_keysBySection);
	
	var _paragraphs = __webpack_require__(244);
	
	var _paragraphs2 = _interopRequireDefault(_paragraphs);
	
	var _bold = __webpack_require__(240);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	var _constants = __webpack_require__(8);
	
	var _flatten = __webpack_require__(310);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _getPageTitle = __webpack_require__(19);
	
	var _getPageTitle2 = _interopRequireDefault(_getPageTitle);
	
	var _reactDocumentTitle = __webpack_require__(11);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _allToolsPairing$chor = _allToolsPairing2.default.chord,
	    keys = _allToolsPairing$chor.keys,
	    matrix = _allToolsPairing$chor.matrix;
	
	
	var allSections = [{ id: 'flavors', label: 'JavaScript Flavors' }, { id: 'frontend', label: 'Front-End Frameworks' }, { id: 'state', label: 'State Management Tools' }, { id: 'backend', label: 'Back-End Frameworks' }, { id: 'testing', label: 'Testing Tools' }, { id: 'style', label: 'CSS & Styling' }, { id: 'build', label: 'Build Tools' }, { id: 'mobile', label: 'Mobile Frameworks' }];
	
	var MAX_NUMBER_OF_SECTIONS = 3;
	
	var text = '\nHow many *React* users also use *Redux*? Do *GraphQL* fans prefer *Webpack*? \nAre *Express* developers also into *Ember*?\n\nThis diagram lets you toggle categories on and off to explore the connections\nbetween the inhabitants of the vast JavaScript ecosystem. You can select up to 3 categories at a time.\n\nThe size of each section corresponds to the number of respondents who have used each library\nand would be willing to use it again. \n';
	
	var Connections = function (_Component) {
	    _inherits(Connections, _Component);
	
	    function Connections() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Connections);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            sections: ['frontend', 'flavors']
	        }, _this.setSections = function (sections) {
	            _this.setState({ sections: sections });
	        }, _this.handleSectionToggle = function (section) {
	            var sections = _this.state.sections;
	
	            var isAlreadySelected = sections.includes(section);
	
	            var newSections = void 0;
	            if (isAlreadySelected) {
	                newSections = sections.filter(function (s) {
	                    return s !== section;
	                });
	            } else {
	                newSections = [].concat(sections, [section]);
	            }
	
	            _this.setState({ sections: newSections });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Connections.prototype.render = function render() {
	        var sections = this.state.sections;
	
	
	        var sectionsKeys = sections.reduce(function (agg, section) {
	            return [].concat(agg, _keysBySection2.default[section]);
	        }, []);
	
	        var keysIndexes = keys.map(function (key, index) {
	            return { key: key, index: index };
	        }).filter(function (_ref) {
	            var key = _ref.key;
	            return sectionsKeys.includes(key);
	        }).map(function (_ref2) {
	            var index = _ref2.index;
	            return index;
	        });
	
	        var filteredKeys = keysIndexes.map(function (index) {
	            return keys[index];
	        });
	        var filteredMatrix = matrix.filter(function (row, index) {
	            return keysIndexes.includes(index);
	        }).map(function (row) {
	            return row.filter(function (item, index) {
	                return keysIndexes.includes(index);
	            });
	        });
	
	        var colors = (0, _flatten2.default)(sections.map(function (section, i) {
	            return _keysBySection2.default[section].map(function (lib) {
	                return _constants.chordScale[i];
	            });
	        }));
	
	        return _react2.default.createElement(
	            _reactDocumentTitle2.default,
	            { title: (0, _getPageTitle2.default)('Connections') },
	            _react2.default.createElement(
	                'div',
	                { className: 'Section' },
	                _react2.default.createElement('div', {
	                    className: 'block block--text',
	                    dangerouslySetInnerHTML: { __html: (0, _bold2.default)((0, _paragraphs2.default)(text)) }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block block--chart block--connections' },
	                    _react2.default.createElement(_AffinityToggle2.default, {
	                        sections: allSections,
	                        selectedSections: sections,
	                        onChange: this.handleSectionToggle,
	                        maxNumberOfSections: MAX_NUMBER_OF_SECTIONS
	                    }),
	                    _react2.default.createElement(_AffinityChord2.default, { colors: colors, keys: filteredKeys, matrix: filteredMatrix })
	                )
	            )
	        );
	    };
	
	    return Connections;
	}(_react.Component);
	
	exports.default = Connections;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-2017-connections-js-f340a9aaa29817dcc7df.js